export default function MessageSent({ message }: { message?: string }) {
  const defaultMessage = 'Your message has been sent.';

  return (
    <div className="flex flex-row items-center justify-center min-h-[200px]">
      <p className="text-gray-700">{message || defaultMessage}</p>
    </div>
  );
}
